import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import apiClient, { formatApiErrorDetail } from "@/lib/api";
import OwnerLayout from "@/components/owner/OwnerLayout";
import PropertyForm from "@/components/property/PropertyForm";

export default function PropertyEditPage() {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    apiClient.get(`/properties/${id}`)
      .then((r) => setProperty(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <OwnerLayout testid="property-edit-page">
      <Link to="/owner/properties" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-primary transition-colors mb-4" data-testid="edit-back-link">
        <ArrowLeft size={16} /> Property Saya
      </Link>
      <h1 className="font-heading text-3xl font-bold tracking-tight mb-6">Edit Property</h1>
      {loading ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-primary" size={28} /></div>
      ) : error ? (
        <div className="rounded-xl bg-destructive/10 border border-destructive/30 px-4 py-3 text-sm text-destructive" data-testid="edit-error">{error}</div>
      ) : (
        <PropertyForm mode="edit" property={property} />
      )}
    </OwnerLayout>
  );
}
